const BUSINESS_CENTER_LABEL = "businesscenterlabel";
const BUSINESS_HOURS_LABEL = "businesshourslabel";
const EXECUTIVE_HOURS_IDENTIFIER = "Business";
const EXECUTIVE_MEMBER_IDENTIFIER = "{executiveMember}";
const EXECUTIVE_MEMBER_LABEL = "executivememberlabel";
const EXECUTIVE_MEMBER_HOURS_LABEL = "executivememberhourslabel";
const MY_WAREHOUSE = "myWarehouse";
const SHOW_WAREHOUSE_DETAILS = "showwarehousedetails";
const HIDE_WAREHOUSE_DETAILS = "hidewarehousedetails";
const PIN_SELECTION = "pinselection";
const SERVICES = "services";
const GAS_PRICES = "gasprices";
const GAS_REGULAR = "gasregular";
const GAS_PREMIUM = "gaspremium";
const GAS_DIESEL = "gasdiesel";
const GAS_ZERO_ETHANOL = "gaszeroethanol";
const HOURS = "hours";
const GET_DIRECTIONS = "getdirections";
const VIEW_STORE_PAGE = "viewstorepage";
const SET_WAREHOUSE_BUTTON_LABEL = "setwarehousebuttonlabel";
const GAS_STATION = "gasstationoption";
const TIRE_CENTER = "tirecenteroption";
const FOOD_COURT = "foodcourtoption";
const HEARING_AIDS = "hearingaidoption";
const OPENING_HOURS_IDENTIFIER = "{openingTime}";
const OPTICAL = "opticaloption";
const PHARMACY = "pharmacyoption";
const CAR_WASH = "carwashoption";
const BUSINESS_CENTER = "businesscenteroption";
const OPEN_HOLIDAY_LABEL = "openholidaylabel";
const CLOSED_HOLIDAY_LABEL = "closedholidaylabel";
const UNIQUE_ID_MY_WAREHOUSE_ICON = "warehousetile-mywarehouse-checkmarkcircle-icon";
const UNIQUE_ID_MY_WAREHOUSE_TEXT = "warehousetile-mywarehouse";
const UNIQUE_ID_MY_WAREHOUSE_PHONE = "warehousetile-seewarehousedetails-phone";
const SERVICE_ERROR_MESSAGE = "serviceErrorMessage";
export {
  BUSINESS_CENTER,
  BUSINESS_CENTER_LABEL,
  BUSINESS_HOURS_LABEL,
  CAR_WASH,
  CLOSED_HOLIDAY_LABEL,
  EXECUTIVE_HOURS_IDENTIFIER,
  EXECUTIVE_MEMBER_HOURS_LABEL,
  EXECUTIVE_MEMBER_IDENTIFIER,
  EXECUTIVE_MEMBER_LABEL,
  FOOD_COURT,
  GAS_DIESEL,
  GAS_PREMIUM,
  GAS_PRICES,
  GAS_REGULAR,
  GAS_STATION,
  GAS_ZERO_ETHANOL,
  GET_DIRECTIONS,
  HEARING_AIDS,
  HIDE_WAREHOUSE_DETAILS,
  HOURS,
  MY_WAREHOUSE,
  OPENING_HOURS_IDENTIFIER,
  OPEN_HOLIDAY_LABEL,
  OPTICAL,
  PHARMACY,
  PIN_SELECTION,
  SERVICES,
  SERVICE_ERROR_MESSAGE,
  SET_WAREHOUSE_BUTTON_LABEL,
  SHOW_WAREHOUSE_DETAILS,
  TIRE_CENTER,
  UNIQUE_ID_MY_WAREHOUSE_ICON,
  UNIQUE_ID_MY_WAREHOUSE_PHONE,
  UNIQUE_ID_MY_WAREHOUSE_TEXT,
  VIEW_STORE_PAGE
};
